export default "__VITE_ASSET__DMxfrNc6__"